import { createReducer, on } from "@ngrx/store";
import {
  fetchCampaign,
  fetchCampaignSuccess,
  fetchCampaignFailure,
  getCampaign,
  getCampaignSuccess,
  getCampaignFailure,
  fetchInvolvedCampaignsFailure,
  fetchInvolvedCampaigns,
  fetchInvolvedCampaignsSuccess
} from "./campaign.actions";

import { IState } from "@models/index";

const initialState: IState = {
  isLoaded: false,
  data: [],
  selectedItem: {},
  involvedCampaigns: [],
  error: null,
  total: 0,
  maxPages: 0,
  perPage: 0,
  currentPage: 0
};

const _campaignReducer = createReducer(
  initialState,
  on(fetchCampaign, (state, { page, filterOptions }) => {
    return state;
  }),
  on(fetchCampaignSuccess, (state, { campaign }) => {
    const payload = {
      isLoaded: true,
      data: campaign.data,
      total: campaign.total,
      maxPages: campaign.maxPages,
      perPage: campaign.perPage,
      currentPage: campaign.currentPage,
      selectedItem: {}
    };

    return { ...state, ...payload };
  }),
  on(fetchCampaignFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(getCampaign, (state, { id }) => {
    const payload = {
      isLoaded: false,
      selectedItem: {},
    };
    return { ...state, ...payload };
  }),
  on(getCampaignSuccess, (state, { campaign }) => {
    const payload = {
      isLoaded: true,
      selectedItem: campaign
    };
    return { ...state, ...payload };
  }),
  on(getCampaignFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(fetchInvolvedCampaigns, (state = null) => {
    const payload = {
      isLoaded: false
    };
    return { ...state, ...payload };
  }),
  on(fetchInvolvedCampaignsSuccess, (state, { campaigns }) => {
    const payload = {
      isLoaded: true,
      involvedCampaigns: campaigns,
    };

    return { ...state, ...payload };
  }),
  on(fetchInvolvedCampaignsFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  })
);

export function campaingReducer(state, action) {
  return _campaignReducer(state, action);
}
